import getSelectedItemsCount from './getSelectedItemsCount';
import { format } from 'owa-strings';
import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';

/**
 * Returns aria-label for the folder name along with the number of mails selected.
 * @param folderName folder name
 * @param selectedCount Number of mails selected in the folder currently
 */
export default function getHeaderAriaLabel(headerText: string): string {
    let ariaLabel: string = '';
    const selectedCount = getSelectedItemsCount();
    if (headerText) {
        const strings = getOwaMiniStrings();

        switch (selectedCount) {
            case -1:
                ariaLabel = headerText;
                break;
            case 0:
                ariaLabel = format(strings.folderWithNoSelectedMessageAriaLabel, headerText);
                break;
            case 1:
                ariaLabel = format(strings.folderWithSingleSelectedMessageAriaLabel, headerText);
                break;
            default:
                ariaLabel = format(
                    strings.folderWithMultipleSelectedMessageAriaLabel,
                    headerText,
                    selectedCount
                );
        }
    }

    return ariaLabel;
}
